import React from 'react';
import PublicLayout from './PublicLayout';

const POSTS = [
  { date: 'Feb 2026', title: 'Why we built the verification gate', summary: 'Background checks belong before the first shift, not after the first complaint.' },
  { date: 'Jan 2026', title: 'Address verification, USPS-style', summary: 'How we use Lob to keep our worker, employer, and location addresses clean.' },
  { date: 'Dec 2025', title: 'Shift swaps without chaos', summary: 'The opinionated approval flow that lets workers trade shifts without management losing visibility.' },
];

export default function BlogPage() {
  return (
    <PublicLayout title="The ScensobConnect blog" eyebrow="Insights">
      <p className="lead">Notes from the team on how we build, what we ship, and what we've learned running staffing software for regulated industries.</p>
      <div className="not-prose grid gap-4 mt-6">
        {POSTS.map((p, i) => (
          <article key={p.title} className="bg-white border border-slate-200 rounded-xl p-6 hover:border-violet-300 transition" data-testid={`blog-post-${i}`}>
            <p className="text-xs uppercase tracking-wider text-violet-600 font-semibold">{p.date}</p>
            <h3 className="text-xl font-semibold text-slate-900 mt-2">{p.title}</h3>
            <p className="text-slate-600 mt-2">{p.summary}</p>
            <p className="text-sm text-slate-400 mt-3">Full post coming soon — subscribe via <a href="mailto:hello@scensobconnect.com" className="text-violet-600 hover:underline">hello@scensobconnect.com</a>.</p>
          </article>
        ))}
      </div>
    </PublicLayout>
  );
}
